import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import { getParentChildSkillsMap } from "PFApp/helpers/get_parent_child_skills_map";
import { getEssentialSkills, getRequiredSkills, getSupportingSkills } from "PFApp/hooks/matches";
import { Id, Importance, Match, Shortlist } from "PFTypes";

import { SkillsCell } from "./skills_cell";

const IMPORTANCE_TO_GETTER_MAP = {
  [Importance.Supporting]: getSupportingSkills,
  [Importance.Essential]: getEssentialSkills,
  [Importance.Required]: getRequiredSkills
};

type SkillsOfImportanceCellProps = {
  importance: Importance;
  match?: Match;
  shortlist?: Shortlist;
};

export const SkillsOfImportanceCell = ({ importance, match, shortlist }: SkillsOfImportanceCellProps) => {
  const activity = useCurrentActivity();

  const getSkills = IMPORTANCE_TO_GETTER_MAP[importance];

  const profileId = (match?.profile.id ?? shortlist?.profile.id) as Id;
  const matchCustomValues = match?.customValues || {
    direct: [],
    indirect: [],
    related: [],
    parent: [],
    child: []
  };
  const applicableCustomValues = (shortlist || match?.shortlist)?.applicableCustomValues;

  const { matchSkills, roleSkills } = getSkills({
    role: activity,
    matchCustomValues,
    applicableCustomValues
  });
  const { parentChildMap } = getParentChildSkillsMap({ customValues: matchCustomValues });

  return (
    <SkillsCell
      profileId={profileId}
      matchSkills={matchSkills}
      roleSkills={roleSkills}
      parentChildMap={parentChildMap}
    />
  );
};
